<div class="wccard px-3 py-1 mb-1">
    <app-companypage-ai [requestaidata]="overviewDataForAISummary" [hasMedianSalary]="jobPostsLoader" [currentCompanyName]="currentCompanyName" [insightstabname]="'overview'" [totalcount]="totalresultscount"></app-companypage-ai>
</div>

<div class="wccard p-3">
    <div class="summarybox mb-4">
        <div class="row">
            <div class="col borderRight pointer" (click)="handelRedirection('totalcount', totalresultscount)">
                <div class="text-center" *ngIf="jobPostsLoader">
                    <img src="../../assets/rolling-loader.gif" style="height: 7vh;" class="img-fluid" alt="Recent Hires">
                </div>
                <p class="f-24 font-weight-600 mb-0 d-flex align-items-center" *ngIf="!jobPostsLoader"><span>{{totalresultscount |
                        number}}</span> <span class="d-flex"></span></p>
                <p class="f-12 text-9696">Professionals <i class="fa-regular fa-info-circle"
                        matTooltip="The total number of professionals within the company."
                        [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
            </div>
            <!-- <div class="col borderRight text-center d-flex justify-content-center">
                <div class="text-left">
                    <p class="f-26 font-weight-600 mb-0 d-flex align-items-center"><span>{{changedjobscount |
                            number}}</span> <span class="d-flex"></span></p>
                    <p class="f-14 text-9696">Changed Jobs <i class="fa-regular fa-info-circle"
                            matTooltip="Professionals who have switched jobs within the past year in their respective fields."
                            [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </div>
            </div> -->

            <div class="col borderRight text-center d-flex justify-content-center align-items-center">
                <div class="text-center" *ngIf="medianTenureLoader">
                    <img src="../../assets/rolling-loader.gif" style="height: 7vh;" class="img-fluid" alt="Recent Hires">
                </div>
                <div class="text-left" *ngIf="!medianTenureLoader">
                    <p class="f-24 font-weight-600 mb-0 d-flex align-items-center">
                        <span [innerHTML]="getFormattedTenureForMatrix(medianTanuresCount)"></span>
                        <span class="d-flex"></span>
                    </p>
                    <p class="f-12 text-9696">Median Tenure <i class="fa-regular fa-info-circle"
                            matTooltip="Median Tenure of the talent" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </div>
            </div>
            <div class="col borderRight text-center d-flex justify-content-center align-items-center">
                <div class="text-center" *ngIf="!hiresAndAttritionObj?.recentGrowth">
                    <img src="../../assets/rolling-loader.gif" style="height: 7vh;" class="img-fluid" alt="Recent Hires">
                </div>
                <div class="text-left pointer" *ngIf="hiresAndAttritionObj?.recentGrowth" (click)="hiresAndAttritionObj?.recentGrowth?.currentYearCount && handelRedirection('recentGrowth', null)">
                    <p *ngIf="showAttritionAndHiringElements('recentGrowth', 'dash')">
                        <i class="fa-solid fa-dash mt-2 mb-2"></i>
                    </p>
                    <p class="mb-0 d-flex align-items-center" *ngIf="showAttritionAndHiringElements('recentGrowth', 'currentYearCount')">
                        <span class="font-weight-600 f-24">
                            {{hiresAndAttritionObj?.recentGrowth?.currentYearCount}}
                        </span>
                        <span class="d-flex align-items-center f-14 ml-2 mr-1">
                            <span *ngIf="hiresAndAttritionObj?.recentGrowth?.increaseRate != null">
                                {{abs(hiresAndAttritionObj?.recentGrowth?.increaseRate)}}%
                            </span>
                            <span *ngIf="hiresAndAttritionObj?.recentGrowth?.increaseRate == null">
                                N/A
                            </span>
                        </span>
                            <i class="fa-solid fa-caret-up f-12 mr-1"
                                *ngIf="hiresAndAttritionObj?.recentGrowth?.increaseRate && hiresAndAttritionObj?.recentGrowth?.currentYearCount"
                                [ngClass]="{ 'fa-rotate-180 mb-1': hiresAndAttritionObj?.recentGrowth?.increaseRate < 0, 'text-danger': hiresAndAttritionObj?.recentGrowth?.increaseRate < 0, 'text-success': hiresAndAttritionObj?.recentGrowth?.increaseRate > 0 }"></i>
                    </p>
                    <p class="f-12 text-9696">Recent Hires (1 Yr)<i class="fa-regular fa-info-circle ml-1"
                            matTooltip="The percentage growth in the overall employee count in the current year when compared to the previous year."
                            [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </div>
            </div>
            <div class="col borderRight text-center d-flex justify-content-center align-items-center">
                <div class="text-center" *ngIf="!hiresAndAttritionObj?.recentAttrtion">
                    <img src="../../assets/rolling-loader.gif" class="img-fluid" style="height: 7vh;" alt="Recent Attrition">
                </div>
                <div class="text-left pointer" *ngIf="hiresAndAttritionObj?.recentAttrtion" (click)="hiresAndAttritionObj?.recentAttrtion?.currentYearCount && handelRedirection('recentAttrtion', null)">
                    <p *ngIf="showAttritionAndHiringElements('recentAttrtion', 'dash')">
                        <i class="fa-solid fa-dash mt-2 mb-2"></i>
                    </p>
                    <p class="mb-0 d-flex align-items-center" *ngIf="showAttritionAndHiringElements('recentAttrtion', 'currentYearCount')">
                        <span class="f-24 font-weight-600">
                            {{hiresAndAttritionObj?.recentAttrtion?.currentYearCount}}
                        </span>
                        <span class="d-flex align-items-center f-14 ml-2 mr-1">
                            <span *ngIf="hiresAndAttritionObj?.recentAttrtion?.increaseRate != null">
                                {{abs(hiresAndAttritionObj?.recentAttrtion?.increaseRate)}}%
                            </span>
                            <span *ngIf="hiresAndAttritionObj?.recentAttrtion?.increaseRate == null">
                                N/A
                            </span>
                        </span>
                            <i class="fa-solid fa-caret-up f-12 mr-1"
                                *ngIf="hiresAndAttritionObj?.recentAttrtion?.increaseRate && hiresAndAttritionObj?.recentAttrtion?.currentYearCount"
                                [ngClass]="{ 'fa-rotate-180 mb-1':  hiresAndAttritionObj?.recentAttrtion?.increaseRate < 0, 'text-danger': hiresAndAttritionObj?.recentAttrtion?.increaseRate < 0, 'text-success': hiresAndAttritionObj?.recentAttrtion?.increaseRate > 0 }">
                            </i>
                    </p>
                    <p class="f-12 text-9696"> Recent Attrition (1 Yr) <i class="fa-regular fa-info-circle ml-1"
                            matTooltip="The proportion and percentage of employees who leave the organization in the current year compared to the prior year"
                            [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </div>
            </div>
               <div class="col" >
                 <div class="text-center" *ngIf="jobPostsLoader">
                    <img src="../../assets/rolling-loader.gif" style="height: 7vh;" class="img-fluid" alt="Recent Hires">
                </div>
                <div *ngIf="!jobPostsLoader" class="text-left"  [ngbTooltip]="jobdemand">
  <p class="f-24 font-weight-600 mb-0 d-flex align-items-center" *ngIf="!jobPostsLoader">
     <span *ngIf="jobDemandCount && jobDemandCount != 0 && jobDemandCount != '0' && professionalsCount != 0" (click)="hasJobListingAccess && openJoblistSlider()" [class.pointer]="hasJobListingAccess">{{jobDemandCount}}</span>
                      <span *ngIf="!jobDemandCount || professionalsCount == 0" style="font-family: Arial, sans-serif;">&mdash;</span>
    <span class="d-flex"></span></p>
                <p class="f-12 text-9696">Active Job Posts </p>
                   <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </div>

            </div>
        </div>
    </div>
    <div class="mb-8">
        <div class="row">
            <div class="col d-flex justify-content-between">
                <p class="f-16 font-weight-600 mb-3">Top locations for talent in {{currentCompanyName | titlecase}}
                </p>
                <span class="" *ngIf="topLocations?.length">
                  <a data-testid="auto-app-overview-tab-a-1" class="view-skills mr-0" routerLink="/company-details/{{currentCompanyName}}/location">View All</a>
                </span>
              </div>

        </div>

        <div class="row align-items-center">
            <div class="col-7">
                <div id="workCountryChart" [hidden]="!(dataSourceWorkCountry && dataSourceWorkCountry?.length)"></div>
                <div class="loader text-center" *ngIf="!dataSourceWorkCountry?.length">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
            </div>
            <div class="col-md-4">
                <div *ngIf="!topLocations?.length">
                    <div class="loader text-center" *ngIf="!locationemptystate">
                        <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                    </div>
                    <div class="loader text-center" *ngIf="locationemptystate">
                        <p class="text-center p-5">No Data Available</p>
                    </div>
                </div>

                <div class="d-flex flex-column test" *ngFor="let location of topLocations">
                    <div class="row">
                        <div class="col-md-9 text-truncate">{{location.key | titlecase}}</div>
                        <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('location', location.key)">{{location.doc_count | number}}</span></div>
                    </div>
                    <hr class="HR-seperator-in-card mb-4 mx-0">
                </div>
            </div>
        </div>
    </div>
    <hr class="HR-seperator-in-card mb-4" *ngIf="companiesGaining?.length || companiesLosing?.length">

    <div class="row">
        <div class="col d-flex justify-content-between">
          <p class="f-16 font-weight-600 mb-3">Which companies are employing this
              talent?</p>
          <span class=""  *ngIf="companiesGaining?.length || companiesLosing?.length">
            <a data-testid="auto-app-overview-tab-a-2" class="view-skills mr-0" routerLink="/company-details/{{currentCompanyName}}/talent-movement">View All</a>
          </span>
        </div>
    </div>

    <div class="row">


        <div class="col">


            <div class="row mb-2" >
                <div class="col-md-9 f-12 text-9696">
                    Companies gaining from
                </div>
                <div class="col f-12 text-9696 d-flex align-items-center">
                    Talent Count
                </div>
            </div>
            <div *ngIf="!companiesGaining?.length">
                <div class="loader text-center" *ngIf="!companyemptystate">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="companyemptystate">
                    <p class="text-center p-5">No Data Available</p>
                </div>
            </div>

            <div class="row mb-2" *ngFor="let company of companiesGaining | slice: 0:5">
                <div class="col-md-9">
                    <div class="d-flex p-2 w-100">
                        <div style="width: 50px; border-right: 1px solid #eceff4;">
                            <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                                <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                                <img [src]="company?.companylogo" [alt]="company?.key" *ngIf="company?.companylogo">
                            </span>
                        </div>



                        <p class="f-16 icon-color mb-1 f-14 position-relative" [ngClass]="{'companyHover': company?.website}">
                            <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                                <span class="position-relative text-capitalize"
                                    [ngClass]="{'dstooltip pointer':company?.website, companyHover: company?.website}">
                                    <span class="text-truncate">{{company.key | titlecase}}</span>
                                    <span class="dstooltip-content">
                                        <app-company-hover-modal [companyInformation]="primaryCompanyInformation" *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                                    </span>
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
                <div class="col f-14 d-flex align-items-center font-weight-600">
                    <span class="pointer" (click)="handelRedirection('winningtalent', company.key)">{{company.doc_count | number}}</span>
                </div>
            </div>

        </div>
        <div class="col">
            <div class="row mb-2">
                <div class="col-md-9 f-12 text-9696">
                    Companies losing to
                </div>
                <div class="col f-12 text-9696 d-flex align-items-center">
                    Talent Count
                </div>
            </div>
            <div *ngIf="!companiesLosing?.length">
                <div class="loader text-center" *ngIf="!companylosingemptystate">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="companylosingemptystate">
                    <p class="text-center p-5">No Data Available</p>
                </div>
            </div>
            <div class="row mb-2" *ngFor="let company of companiesLosing | slice: 0:5">
                <div class="col-md-9">
                    <div class="d-flex p-2 w-100">
                        <div style="width: 50px; border-right: 1px solid #eceff4;">
                            <span class="compnaylogoplaceholder" [ngClass]="{'logobgcolor':!company?.companylogo}">
                            <i class="fas fa-building f-12" *ngIf="!company?.companylogo"></i>
                            <img [src]="company?.companylogo" [alt]="company?.key" *ngIf="company?.companylogo">
                            </span>
                        </div>
                        <!-- <div style="margin-left: 24px;" class="d-grid" [matTooltip]="company.key | titlecase"
                            [matTooltipClass]="{ 'red-tooltip text-black': true }">
                            <span class="text-truncate">{{company.key | titlecase}}</span>
                        </div> -->

                        <p class="f-16 icon-color mb-1 f-14 position-relative" [ngClass]="{'companyHover': company?.website}">
                            <span class="" (mouseenter)="getCompanyInfo(company?.key)">
                                <span class="position-relative text-capitalize"
                                    [ngClass]="{'dstooltip pointer':company?.website, companyHover: company?.website}">
                                    <span class="text-truncate">{{company.key | titlecase}}</span>
                                    <span class="dstooltip-content">
                                        <app-company-hover-modal [companyInformation]="primaryCompanyInformation" *ngIf="primaryCompanyInformation"></app-company-hover-modal>
                                    </span>
                                </span>
                            </span>
                        </p>

                    </div>
                </div>
                <div class="col f-14 d-flex align-items-center font-weight-600">
                    <span class="pointer" (click)="handelRedirection('losingtalent', company.key)">{{company.doc_count | number}}</span>
                </div>
            </div>

        </div>
    </div>
    <hr class="HR-seperator-in-card mb-4">
    <div class="row">
        <div class="col d-flex justify-content-between">
            <p class="f-16 font-weight-600 mb-3">Schools producing talent for {{currentCompanyName | titlecase}}</p>
            <span class="d-flex">
              <a data-testid="auto-app-overview-tab-a-3" class="view-skills" *ngIf="school?.length" routerLink="/company-details/{{currentCompanyName}}/education">View School</a>
              <span *ngIf="school?.length && fieldOfStudy?.length" class="vectordiv">|</span>
              <a data-testid="auto-app-overview-tab-a-4" class="view-titles" *ngIf="fieldOfStudy?.length" routerLink="/company-details/{{currentCompanyName}}/education">View Study</a>
            </span>
        </div>

    </div>
    <div class="row">
        <div class="col">
            <div class="row mb-3">
                <div class="col-md-9 f-12 text-9696">
                    School
                </div>
                <div class="col f-12 text-9696 d-flex align-items-center">
                    Talent Count
                </div>
            </div>
            <div *ngIf="!school?.length">
                <div class="loader text-center" *ngIf="!schoolemptystate && showSchoolLoader">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="schoolemptystate">
                    <p class="text-center p-5">No Data Available</p>
                </div>
            </div>


            <div class="test" *ngFor="let s of school | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{s.key | titlecase}}</span>
                    </div>
                    <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('school', s.key)">{{s.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
        <div class="col">
            <div class="row mb-3">
                <div class="col-md-9 f-12 text-9696">
                    Fields of Study
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div *ngIf="!fieldOfStudy?.length">
                <div class="loader text-center" *ngIf="!fieldofstudyemptystate">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="fieldofstudyemptystate">
                    <p class="text-center p-5">No Data Available</p>
                </div>
            </div>


            <div class="test" *ngFor="let fs of fieldOfStudy | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{fs.key | titlecase}}</span>
                    </div>
                    <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('fieldofstudy', fs.key)">{{fs.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
    </div>
    <hr class="HR-seperator-in-card mb-4">
    <div class="row">
        <div class="col d-flex justify-content-between">
            <p class="f-16 font-weight-600 mb-4">Related skills and titles for this talent</p>
             <span class="d-flex">
              <a data-testid="auto-app-overview-tab-a-5" class="view-skills" *ngIf="skills?.length" routerLink="/company-details/{{currentCompanyName}}/skills">View Skills</a>
              <div class="vectordiv" *ngIf="skills?.length && titles?.length">|</div>
              <a data-testid="auto-app-overview-tab-a-6" class="view-titles" *ngIf="titles?.length"  routerLink="/company-details/{{currentCompanyName}}/titles">View Titles</a>
            </span>
        </div>

    </div>
    <div class="row">
        <div class="col">
            <div *ngIf="!skills?.length">
                <div class="loader text-center" *ngIf="!skillemptystate">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="skillemptystate">
                    <p class="text-center p-5">No Data Available</p>
                </div>
            </div>

            <div class="row mb-3" *ngIf="skills?.length">
                <div class="col-md-9 f-12 text-9696">
                    Skills
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div class="test" *ngFor="let s of skills | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{s.key | titlecase}}</span>
                    </div>
                    <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('skills', s.key)">{{s.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
        <div class="col">
            <div *ngIf="!titles?.length">
                <div class="loader text-center" *ngIf="!titlesemptystate">
                    <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
                </div>
                <div *ngIf="titlesemptystate">
                    <p class="text-center p-5">No Data Available</p>
                </div>
            </div>

            <div class="row mb-3" *ngIf="titles?.length">
                <div class="col-md-9 f-12 text-9696">
                    Titles
                </div>
                <div class="col f-12 text-9696">
                    Talent Count
                </div>
            </div>
            <div class="test" *ngFor="let t of titles | slice: 0:5">
                <div class="row">
                    <div class="col-md-9 d-grid">
                        <span class="text-truncate">{{t.key | titlecase}}</span>
                    </div>
                    <div class="col font-weight-600"><span class="pointer" (click)="handelRedirection('jobtitle', t.key)">{{t.doc_count | number}}</span></div>
                </div>
                <hr class="HR-seperator-in-card mb-4 mx-0">
            </div>
        </div>
    </div>
</div>
<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>

